import * as Types from "../Constants/AllConstants";


export const ActivateSmsTrialReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ACTIVATE_SMS_TRIAL_REQUEST:
      return { loading: true };
    case Types.ACTIVATE_SMS_TRIAL_SUCCESS:
      return { loading: false, success: true, subscription: action.payload };
    case Types.ACTIVATE_SMS_TRIAL_FAIL:
      return { loading: false, error: action.payload };
    case Types.RESET_TRIAL_ACTIVATION:
      return {};
    default:
      return state;
  }
};

export const ActivateEmailTrialReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ACTIVATE_EMAIL_TRIAL_REQUEST:
      return { loading: true };
    case Types.ACTIVATE_EMAIL_TRIAL_SUCCESS:
      return { loading: false, success: true, subscription: action.payload };
    case Types.ACTIVATE_EMAIL_TRIAL_FAIL:
      return { loading: false, error: action.payload };
    case Types.RESET_TRIAL_ACTIVATION:
      return {};
    default:
      return state;
  }
};

export const CheckTrialEligibilityReducer = (state = { eligibility: {} }, action) => {
  switch (action.type) {
    case Types.CHECK_TRIAL_ELIGIBILITY_REQUEST:
      return { loading: true };
    case Types.CHECK_TRIAL_ELIGIBILITY_SUCCESS:
      return { loading: false, eligibility: action.payload };
    case Types.CHECK_TRIAL_ELIGIBILITY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


export const UpgradeSmsSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.UPGRADE_SMS_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case Types.UPGRADE_SMS_SUBSCRIPTION_SUCCESS:
      return { loading: false, success: true, subscription: action.payload };
    case Types.UPGRADE_SMS_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case Types.RESET_UPGRADE_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};

export const UpgradeEmailSubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.UPGRADE_EMAIL_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case Types.UPGRADE_EMAIL_SUBSCRIPTION_SUCCESS:
      return { loading: false, success: true, subscription: action.payload };
    case Types.UPGRADE_EMAIL_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    case Types.RESET_UPGRADE_SUBSCRIPTION:
      return {};
    default:
      return state;
  }
};


export const SmsTrialInfoReducer = (state = { info: {} }, action) => {
  switch (action.type) {
    case Types.GET_SMS_TRIAL_INFO_REQUEST:
      return { loading: true };
    case Types.GET_SMS_TRIAL_INFO_SUCCESS:
      return { loading: false, info: action.payload };
    case Types.GET_SMS_TRIAL_INFO_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const EmailTrialInfoReducer = (state = { info: {} }, action) => {
  switch (action.type) {
    case Types.GET_EMAIL_TRIAL_INFO_REQUEST:
      return { loading: true };
    case Types.GET_EMAIL_TRIAL_INFO_SUCCESS:
      return { loading: false, info: action.payload };
    case Types.GET_EMAIL_TRIAL_INFO_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};